var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("404")]),_c('h2',{staticClass:"sub-title"},[_vm._v("not found")])])
}]

export { render, staticRenderFns }